var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.471,
    height: 105.59,
    viewBox: "0 0 87.471 105.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_51832",
    "data-name": "Path 51832",
    d: "M941.636,332.892c-14.291-4.594-18.175-103.616-2.495-105.163,18.961-1.871,76.345,29.94,77.344,50.9C1017.37,297.2,955.608,337.383,941.636,332.892Z",
    transform: "translate(-929.023 -227.65)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlayIcon);
export default __webpack_public_path__ + "static/media/white_play_icon.f04ed03b8e9e0961e6098be59ec0c88a.svg";
export { ForwardRef as ReactComponent };